<template>
    <b-modal
      centered
      @show="onShow"
      :hide-footer="false"
      modal-class="c-wrap"
      dialog-class="c-dialog"
      header-class="popup_header"
      footer-class="popup_footer"
      content-class="c-content"
      body-class="c-body container"
      :visible="visible"
      @hide="hide"
    >
      <template #modal-header="{ close }" style="width: 100%; display: flex; justify-content: center">
        <p style="margin: auto" class="modal-header-title">
          {{$store.getters.getIsAutoPage ? $store.getters.getAutoNotificationTitle :
          notify_idx == 0 ? $t("more.send_noti") : $t("more.noti_modify")}}
        </p>
      </template>
      <div class="leftright">
        <b-button v-if="isAuto == 'N' && !$store.getters.getCopyNotification && !$store.getters.getModifyNotification"
                  class="copy_prev_btn copy_prev_btn_txt"
                  @click="onSetAutoNotify">
          {{$t('more.auto_noti_setting')}}
        </b-button>
        <div v-else></div>
        <b-button class="copy_prev_btn copy_prev_btn_txt"
                  @click="onCopyPrevNotify">
          {{$t('more.copy_previous_notifications')}}
        </b-button>
      </div>
      <b-form-input type="text" class="input input-text-title" style="margin-top: 12px"
                    v-model="title"
                    :placeholder="$t('community.title_placeholder')"/>
      <div class="leftright" style="margin-top: 5px">
        <b-form-input type="text" class="input input-text-title" style="flex:1"
                      v-model="site_name"
                      readonly
                      :placeholder="$t('more.site_name_placeholder1')"/>
        <b-button class="link_btn link_btn_text"
                  @click="showSitePicker = true">
          {{$t('more.link_my_site')}}
        </b-button>
      </div>
      <div style="display: none">
        <div class="leftright" style="margin-top: 5px">
          <b-form-input type="text" class="input input-text-title" style="flex:1"
                        v-model="address"
                        readonly
                        :placeholder="$t('more.search_address')"/>
          <b-button class="link_btn link_btn_text"
                    @click="showAddressPopup = true">
            {{$t('more.address_search')}}
          </b-button>
        </div>
        <div class="center" style="margin-top: 5px">
          <div class="center" style="flex:1">
            <b-form-input type="text" class="input input-text-title" style="width: 70px"
                          v-model="contact_name1"
                          placeholder="홍길동"/>
            <b-form-input type="text" class="input input-text-title" style="flex:1; margin-left: 6px"
                          v-model="contact_phone1"
                          :formatter="Utils.formatPhoneNumber"
                          placeholder="010-0000-0000"/>
          </div>
          <div class="center" style="flex:1; margin-left: 6px">
            <b-form-input type="text" class="input input-text-title" style="width: 70px;"
                          v-model="contact_name2"
                          placeholder="홍길동"/>
            <b-form-input type="text" class="input input-text-title" style="flex:1; margin-left: 6px"
                          v-model="contact_phone2"
                          :formatter="Utils.formatPhoneNumber"
                          placeholder="010-0000-0000"/>
          </div>
        </div>
      </div>
      <b-form-textarea
        class="input input-text-title"
        style="margin-top: 5px; padding: 8px; height: 358px"
        v-model="content"
        :placeholder="$t('community.content_placeholder')"/>
      <div class="leftright" style="margin-top: 18px">
        <b-button @click="add_file" class="attach_btn">{{$t("community.attachments")}}</b-button>
        <input @change="on_img_change()" type="file" name="file" accept="image/*" ref="img-input" style="display: none" />
      </div>
      <div v-for="(it ,idx) in image"
           @click="image = image.filter((it1, idx1) => {return idx != idx1})"
           class="input leftright"
           style="width: 100%; margin-top: 6px">
        <div>
          <b-img :src="require('../../../assets/image/ic_file.png')" style="height: 1em;"/>
          <span class="file_name">{{it.name}}</span>
        </div>
        <b-img :src="require('../../../assets/image/ic_close3@2x.png')" style="height: 1.3em;"/>
      </div>
      <div class="leftright" style="margin-top: 1em; margin-bottom: 2em;">
        <div class="guide" style="width: 46%;">
          {{$t("community.made_guide")}}
        </div>
        <div>
          <div @click="change_push" :class="['custom-but', pushEditable?'':'disable']">
            <b-img :src="push_src" style="width: 1em;height: 1em;"/>
            <span style="margin-right: 6px;" >{{$t("community.push")}}</span>
          </div>
          <div @click="change_made" :class="['custom-but', madeEditable?'':'disable']" style="margin-left: 0.5em; width: 110px;">
            <b-img :src="made_src" style="width: 1em;height: 1em;"/>
            <span style="margin-left: 3px;" >{{$t("community.made_plus")}}</span>
          </div>
        </div>
      </div>
      <template #modal-footer="{close}">
        <div class="c-footer">
          <b-button  @click="()=>{
          hide();
          $store.commit('setCopyNotification', false);
          $store.commit('setAutoNotificationInfo',{});
          $store.commit('setAutoNotificationTitle', null);
          $store.commit('setModifyNotification', null);
        }" class="footer-btn" style="background: #cacbcd">{{$t('common.cancel')}}</b-button>
          <b-button @click="onComplete" variant="primary" class="footer-btn">{{$t('common.complete1')}}</b-button>
        </div>
      </template>
      <SiteSelectPopup
        :visible.sync="showSitePicker"
        type="1"
        @select="item => {
          let contact_list = item.f_contact_list ? item.f_contact_list : [];
          self.site_idx= item.f_idx;
          self.site_name= item.f_name;
          self.address= item.f_address1;
          self.contact_name1= contact_list.length > 0 ? contact_list[0].f_name : this.contact_name1;
          self.contact_phone1= contact_list.length > 0 ? contact_list[0].f_phone : this.contact_phone1;
          self.contact_name2= contact_list.length > 1 ? contact_list[1].f_name : this.contact_name2;
          self.contact_phone2= contact_list.length > 1 ? contact_list[1].f_phone : this.contact_phone2;
          // self.showSitePicker= false;
          self.getTodayWritingCountPerSite(item.f_idx);
        }"/>
      <AddressSearchPopup
        :visible.sync="showAddressPopup"
        @onConfirm="(addr, detailAddress) => {
        this.address =addr + ' ' + detailAddress;
      }"
      />

    </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
const $u = require('util');

import MdSingleCheckBox from "../mf/MdSingleCheckBox";
import CSelect from "../CSelect";
import SiteSelectPopup from "./SiteSelectPopup"
import AddressSearchPopup from "./AddressSearchPopup"

import IS_OFFLINE_MODE from "../../../config/constant";

export default {
  name: "NotifyWritePopup",
  components: {
    MdSingleCheckBox,
    CSelect,
    SiteSelectPopup,
    AddressSearchPopup,
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    info:{
      type:Object,
      default:null,
    },
    onEdit:{
      type:Function
    },
    type:{
      type:String,
      default:"notify"
    },
    pageTitle:{
      type:String,
      default:''
    },
    isAuto:{
      type:String,
      default:'N',
    }
  },
  data() {
    return {
      self: this,
      u:$u,
      Utils:Utils,
      title: '',
      content: '',
      image: [],
      showTooltip: false,
      isAutoEnable: 'N',
      time: '00:00',
      interval: 'E',
      notify_idx: 0,
      site_idx: IS_OFFLINE_MODE ? 59 : 0,
      site_name: IS_OFFLINE_MODE ? 'site name' : '',
      address: IS_OFFLINE_MODE ? 'address' : '',
      push: 'N',
      made: 'N',
      made1: 'N',
      pushEditable: true,
      madeEditable: true,
      contact_name1: '',
      contact_phone1: '',
      contact_name2: '',
      contact_phone2: '',
      writeLeft: 2,
      writeLimit: 2,
      showSitePicker: false,
      showAddressPopup: false,
    }
  },
  inject: ['eventBus'],
  methods:{
    onSetAutoNotify() {
      if (this.$route.path === '/notify') {
        this.hide();
        this.$emit('move', this.$c.NOTIFY_TAB.AUTO);
      } else {
        this.$store.commit('setNotifyTabIndex', this.$c.NOTIFY_TAB.AUTO);
        this.$router.push('/notify');
      }
    },
    onCopyPrevNotify() {
      this.$store.commit('setCopyNotification', true);
      if (this.isAuto == 'Y'){
        this.$store.commit('setAutoNotification', true);
      }
      if (this.$route.path === '/notify') {
        this.hide();
        // this.$emit('move', this.$c.NOTIFY_TAB.AUTO);
        this.$emit('move', this.$c.NOTIFY_TAB.MODIFY);
        this.$emit('return', this.isAuto == 'Y' ? this.$c.NOTIFY_TAB.AUTO : this.$c.NOTIFY_TAB.MODIFY);
      } else {
        this.$store.commit('setNotifyTabIndex', this.$c.NOTIFY_TAB.MODIFY);
        this.$router.push('/notify');
      }
    },
    getTodayWritingCountPerSite(site_idx=-1){
      Utils.requestGet(this.$c.API.Notify.getTodayWritingCount, {site_idx: site_idx}).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.setState(this,{
            writeLeft: result.data.left,
            writeLimit: result.data.limit,
          });
        } else {
         Utils.toast(this, result.msg);
        }
      });
    },

    onComplete(){
      if (this.title == '') {
        Utils.toast(this,this.$t("community.title_placeholder"));
        return;
      }
      if (this.site_name == '') {
        Utils.toast(this,this.$t("more.no_site"));
        return;
      }
      /*if (this.address == '') {
        Utils.toast(this,this.$t("more.address_placeholder"));
        return;
      }*/
      if (this.content == '') {
        Utils.toast(this, this.$t("community.content_placeholder"));
        return;
      }
      this.getProfile();
      let contacts = [];
      if (this.contact_name1 != '' && this.contact_phone1 != '') {
        contacts.push({name: this.contact_name1, phone: this.contact_phone1});
      }
      if (this.contact_name2 != '' && this.contact_phone2 != '') {
        contacts.push({name: this.contact_name2, phone: this.contact_phone2});
      }
      /*if (contacts.length < 1) {
        Utils.toast(this, this.$t('community.contacts_input'));
        return;
      }*/
      let isAuto = this.$store.getters.getIsAutoPage ? 'Y' : this.isAuto;
      Utils.requestPost(
        this.notify_idx == 0 ? this.$c.API.Notify.addNotify : this.$c.API.Notify.updateNotify,
        {
          notify_idx: this.notify_idx,
          title: this.title,
          content: this.content,
          site_name: this.site_name,
          address: this.address,
          made: this.made == 'Y' || this.made1 == 'Y' ? 'Y' : 'N',
          push: this.push,
          isAuto: isAuto,
          site_idx: this.site_idx,
          isAutoEnable: this.isAutoEnable,
          time: this.time,
          interval: this.interval,
          image: '',
          image_url: this.image.map(it => {
            return it.url
          }).join(','),
          contacts: JSON.stringify(contacts),
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.hide();
          this.$store.commit('setCopyNotification', false);
          if (isAuto == 'Y'){
            this.$emit('move', this.$c.NOTIFY_TAB.AUTO);
          }else{
            this.$emit('move', this.$c.NOTIFY_TAB.MODIFY);
          }
          this.$store.commit('setAutoNotificationInfo',{});
          this.$store.commit('setAutoNotificationTitle',null);
          this.$store.commit('setModifyNotification',null);
          this.$emit('save');
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    getProfile() {
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          // this.myinfo.saveInfo();
          this.myinfo.loadInfo();
        } else {
        }
      });
    },

    initState(){
      Utils.setState(this,{
        title: '',
        content: '',
        image: [],
        showTooltip: false,
        isAutoEnable: 'N',
        time: '00:00',
        interval: 'E',
        notify_idx: 0,
        site_idx: IS_OFFLINE_MODE ? 59 : 0,
        site_name: IS_OFFLINE_MODE ? '등록된 현장정보를 연결하세요.' : '',
        address: IS_OFFLINE_MODE ? '주소를 검색하세요.' : '',
        push: 'N',
        made: 'N',
        made1: 'N',
        pushEditable: true,
        madeEditable: true,
        contact_name1: '',
        contact_phone1: '',
        contact_name2: '',
        contact_phone2: '',
        writeLeft: 2,
        writeLimit: 2,
        showSitePicker: false,
        showAddressPopup: false,
      });
    },
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
      let info = this.info;
      if (info == null) {
        this.initState();
        if (!Utils.isEmpty(this.$store.getters.getAutoNotificationInfo) && !Utils.isEmpty(this.$store.getters.getAutoNotificationInfo.f_auto_enable)) {
          Utils.setState(this,{
            isAutoEnable: this.$store.getters.getAutoNotificationInfo.f_auto_enable,
            time: this.$store.getters.getAutoNotificationInfo.f_auto_time,
            interval: this.$store.getters.getAutoNotificationInfo.f_auto_interval,
          });
        }
        this.getTodayWritingCountPerSite();
      } else {
        let contact_name1 = '', contact_name2 = '', contact_phone1 = '', contact_phone2 = '';
        if (info.contacts_list.length > 0) {
          contact_name1 = info.contacts_list[0].f_name;
          contact_phone1 = info.contacts_list[0].f_phone;
        }
        if (info.contacts_list.length > 1) {
          contact_name2 = info.contacts_list[1].f_name;
          contact_phone2 = info.contacts_list[1].f_phone;
        }
        this.$store.commit('setAutoNotificationInfo', {
          f_auto_enable: info.f_auto_enable,
          f_auto_time: info.f_auto_time,
          f_auto_interval: info.f_auto_interval,
        });
        Utils.setState(this, {
          notify_idx: this.$store.getters.getModifyNotification ? this.$store.getters.getModifyNotification : this.$store.getters.getCopyNotification ? 0 : info.f_idx,
          site_idx: info.f_site_idx,
          site_name: info.f_site_name,
          title: info.f_title,
          content: info.f_content,
          address: info.f_address,
          push: info.f_push,
          pushEditable: this.$store.getters.is_copy_notification ? true : info.f_auto == 'Y' ? true : info.f_push == 'N',
          made: info.f_made,
          made1: info.f_made1,
          madeEditable: this.$store.getters.is_copy_notification ? true : info.f_auto == 'Y' ? true : info.f_made1 == 'N',
          contact_name1: contact_name1,
          contact_phone1: contact_phone1,
          contact_name2: contact_name2,
          contact_phone2: contact_phone2,
          isAutoEnable: Utils.isEmpty(this.$store.getters.getAutoNotificationInfo) ? info.f_auto_enable : this.$store.getters.getAutoNotificationInfo.f_auto_enable,
          time: Utils.isEmpty(this.$store.getters.getAutoNotificationInfo) ? info.f_auto_time : this.$store.getters.getAutoNotificationInfo.f_auto_time,
          interval: Utils.isEmpty(this.$store.getters.getAutoNotificationInfo) ? info.f_auto_interval : this.$store.getters.getAutoNotificationInfo.f_auto_interval,
          image: info.f_image_url == '' ? [] : info.f_image_url.split(',').map(it => {
            return {
              name: it.substr(it.lastIndexOf('/') + 1),
              url: it
            };
          }),
        });
        // this.getTodayWritingCountPerSite(info.f_site_idx);
      }
    },

    change_push(){
      if (!this.pushEditable) {
        return;
      }
      if (this.push == 'Y') {
        this.push = 'N';
        return;
      }
      Utils.showConfirm2(this, '<p style="font-size: 22px;">'+this.$t("community.push_title")+'</p>'+
        '<p style="color: gray; font-size: 20px;">'+$u.format(this.$t("community.push_content"), this.myinfo.setting.notify_made_point)+'</p>'+
        '<p style="color: #cf0000; text-decoration: underline; margin-bottom: 0;font-size: 20px;">'+$u.format(this.$t("community.push_content1"), Math.max(0, this.myinfo.pushCnt))+'</p>'
      ).then(value =>{
        if(value){
          this.push = 'Y';
        }
      });
    },
    change_made(){
      if (!this.madeEditable) {
        return;
      }
      if (this.made == 'Y' || this.made1 == 'Y') {
        this.made = 'N';
        this.made1 = 'N';
        return;
      }
      Utils.showConfirm2(this, '<p style="font-size: 22px;">'+this.$t("community.made_title")+'</p>'+
        '<p style="color: gray; font-size: 20px;margin-bottom: 0;">'+$u.format(this.$t("community.made_content_1"), this.myinfo.setting.notify_made_point)+'</p>'+
        '<p style="color: gray; font-size: 20px;">'+this.$t("community.made_content_2")+'</p>'+
        '<p style="color: #cf0000; text-decoration: underline; margin-bottom: 0; font-size: 20px;">'+$u.format(this.$t("community.made_content1"), Math.max(0, this.myinfo.madeCnt))+'</p>'
      ).then(value =>{
        if(value){
          this.made = 'Y';
        }
      });
    },
    on_img_change(){
      var file = this.$refs['img-input'].files[0];
      var name = this.$refs['img-input'].value;
        name = name.substr(name.lastIndexOf('\\') + 1);
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
            this.image.push(
              {
                name : name,
                url : result.data.url
              });
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    add_file(){
      this.$refs["img-input"].click();
    },

    hide(){
      if (this.visible) {
        if(window.history.state == "forward"){
          window.history.back();
        }
        this.initState();
      }
    },

    replaceEnter(text){
      return text.replace(/\n/g, " ");
    },
     },
  watch: {
    visible: function (){
      if (this.visible)
        this.onShow();
    },
  },
  computed:{
    typeOptions(){
      var ret={};
      var temp = Object.entries(this.$c.COMMUNITY_CATEGORY1).filter(it => {
        return this.myinfo.isAdmin() ? true : it[1] != this.$t('community.notice')
      });
      for(let i =0 ; i< temp.length; i++){
        ret[temp[i][0]] = temp[i][1];
      }
      return ret;
    },
    made_src(){
      return this.made == 'Y' || this.made1 == 'Y' ? require('../../../assets/image/ic_check_red_on@2x.png') :require('../../../assets/image/ic_check_red_off@2x.png');
    },
    push_src(){
      return this.push == 'Y'? require('../../../assets/image/ic_check_red_on@2x.png') :require('../../../assets/image/ic_check_red_off@2x.png');
    }
  },
  // mounted() {
  //   this.myinfo.loadInfo();
  //   this.phone= Utils.formatPhoneNumber(this.myinfo.phone);
  // }

}
</script>

<style scoped lang="scss">
@import "../../../assets/css/vars";

.setting_btn {
  align-items: center;
  justify-content: center;
  background-color: $c_457fff;
  border-radius: 5px;
  width: 83px;
  height: 32px;
  font-size: $fs_12;
  padding: 0;
}

.add_btn {
  align-items: center;
  justify-content: center;
  background-color: #0840ba!important;
  border-radius: 4px;
  width: 83px;
  height: 32px;
  font-size: $fs_12;
  padding: 0;
  margin-top: 5px;
}


.disable{
  background-color: #ddddde!important;
}

::placeholder{
  color: #666666;
}

.c-footer{
  width: 600px;
  height: 50px;
  display: flex;
  position: relative;
  bottom: 0;
  margin: 0;
  //left: -16px;
  //padding: 0px 20px;
}

.footer-btn{
  background: $c_457fff;
  flex: 1;
  margin: 0;
  border-radius: 0;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.leftright{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header-title{
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  color: $text;
}

.center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.attach_btn {
  padding: 0;
  width: 70px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: #3d3d3e;
  border-radius: 3px;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
}
.file_name{
  color: #666666;
  font-size: $fs_16;
  font-family: $korean_gd_13_r;
  margin-left: 5px;
}

.guide{
  text-align: center;
  color: #cf0000;
  font-size: $fs_16;
  font-family: $korean_gd_13_r;
  margin:0 7px;
  line-height: 20px;
}

.custom-but{
  width:100px;
  height: 40px;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background: #cf0000;
  color:white;
  padding: 0.3em 10px;
  cursor:pointer;
}

.disable{
  background-color: #cacbcd;
}

.tooltip_btn{
  cursor: pointer;
  color:$primary;
  text-decoration: underline;
  float:right;
  margin-top: 1.5em;
  font-size: $fs_11;
  padding-bottom: 5em;
}

.link_btn{
  padding: 0;
  width: 110px;
  height: 36px;
  background-color: $c_457fff;
  //border-radius: 5px;
  margin-left: 5px;
}
.link_btn_text{color: $white; font-size: $fs_14; font-family: $korean_gd_14_r};

.copy_prev_btn{
  @extend .link_btn;
  margin-left: 0;
}

.copy_prev_btn_txt{
  @extend .link_btn_text;
}
//.tooltip-body{
//  background: rgba(105, 105, 105, .9);
//}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/NotifyWritePopup.vue